import * as React from 'react'
import { theme } from '../theme'

interface Props {
    value: string
    onChange: (value: string) => void
    label?: string
}

export const CustomPromptInput = ({
    value,
    onChange,
    label = 'Describe your picture'
}: Props) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing.sm,
            }}
        >
            <label
                style={{
                    fontSize: '12px',
                    color: theme.colors.text.secondary,
                }}
            >
                {label}
            </label>
            <textarea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Enter prompt describing your image to guide AI in image generation"
                style={{
                    width: '100%',
                    minHeight: '80px',
                    padding: theme.spacing.sm,
                    borderRadius: theme.borderRadius.sm,
                    border: `1px solid ${theme.colors.border}`,
                    backgroundColor: theme.colors.background,
                    color: theme.colors.text.primary,
                    fontSize: '12px',
                    resize: 'vertical',
                }}
            />
        </div>
    )
}
